import { getRegion } from './Region';

export const getTranslation = (key, translations) =>
  typeof translations?.[key] === 'string' ? translations?.[key] : '';

export const jsonParseTraslation = translations => {
  try {
    return JSON.parse(translations)?.language?.[getRegion()];
  } catch (error) {
    console.warn(error);
    return {};
  }
};

export const jsonParseCatch = json => {
  try {
    return JSON.parse(json);
  } catch (error) {
    console.warn(error);
    return {};
  }
};

export const getTranslationEmptyOrNullKey = (key, translations) => {
  if (Object?.hasOwn(translations, key)) {
    return typeof translations?.[key] === 'string' ? translations?.[key] : '';
  }
  return typeof key === 'string' ? key : '';
};
